/**
 * Geld wird überall als Integer in Cent geführt.
 * Anzeige: `12,50 €` mit geschütztem Leerzeichen (wie Regal.formatEuro im Design-System).
 */

const NBSP = " ";

export function formatEuro(cent: number): string {
  const neg = cent < 0;
  const abs = Math.abs(cent);
  const euro = Math.floor(abs / 100);
  const rest = abs % 100;
  const euroStr = euro.toLocaleString("de-DE");
  return `${neg ? "−" : ""}${euroStr},${rest.toString().padStart(2, "0")}${NBSP}€`;
}

/** "12,50" | "12.5" | "1.234,56" → 1250 Cent. Ungültig → null. */
export function parseEuro(eingabe: string): number | null {
  const s = eingabe.trim().replace(/\s|€/g, "");
  if (!s) return null;
  // Tausenderpunkte entfernen, wenn Komma als Dezimaltrenner vorhanden ist
  const normal = s.includes(",") ? s.replace(/\./g, "").replace(",", ".") : s;
  if (!/^-?\d+(\.\d{1,2})?$/.test(normal)) return null;
  const neg = normal.startsWith("-");
  const [ganz, dez = ""] = normal.replace("-", "").split(".");
  const cent = Number(ganz) * 100 + Number((dez + "00").slice(0, 2));
  return neg ? -cent : cent;
}

/**
 * Prozentanteil in Cent, kaufmännisch gerundet (halb aufrunden), je Position angewendet.
 * Beispiel: provisionCent(1250, 15) = 188 (187,5 → 188).
 */
export function anteilCent(betragCent: number, prozent: number): number {
  const roh = (betragCent * prozent) / 100;
  return roh >= 0 ? Math.floor(roh + 0.5) : -Math.floor(-roh + 0.5);
}

export function summe(betraege: Iterable<number>): number {
  let s = 0;
  for (const b of betraege) s += b;
  return s;
}
